"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { AccountSessionMixins } from "@/service/account-session";
import { UiConfirm } from "@/service/ConfirmBox/confirm";
import API from "@ym-framework/api-utils";
import { Component, Mixins, PropSync } from "vue-property-decorator";
let BatchDelete = class extends Mixins(AccountSessionMixins) {
  get show() {
    return true;
  }
  deleteItems() {
    return __async(this, null, function* () {
      try {
        let _ids = [];
        for (let item of this._controller) {
          _ids.push(item.guid);
        }
        yield UiConfirm.confirm(
          this.$t("team_management.multi_delete.dialog.message"),
          this.$t("team_management.multi_delete.dialog.title"),
          {
            confirmButtonText: this.$t(
              "team_management.multi_delete.dialog.confirm"
            ),
            cancelButtonText: this.$t(
              "team_management.multi_delete.dialog.cancel"
            ),
            iconClass: "el-icon-warning"
          }
        );
        let response = yield API.post(
          `api://base.auth/api/v7/users/delete_users`,
          {
            user_guid_list: _ids
          }
        );
        this.$message.success(
          this.$t("team_management.multi_delete.dialog.success_message")
        );
        this.$emit("refresh");
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
__decorateClass([
  PropSync("selectItem")
], BatchDelete.prototype, "_controller", 2);
BatchDelete = __decorateClass([
  Component
], BatchDelete);
export {
  BatchDelete as default
};
